// extracted by mini-css-extract-plugin
module.exports = {"price":"EQ-z","onSale":"FQ-z"};